<template>
  <div style="width: 100%">
    <MessageComposer
      showLabel
      autofocus
      dense
      outlined
      submitButtonTestId="taskComposer-button-send"
      :disableSubmitButton="isLoading"
      :submitButtonText="$t('common.button.send')"
      :accountSuggestions="accountSuggestions"
      :initialMentionedAccounts="initialMentionedAccounts"
      :initialMessage="initialContent"
      :isSearchingAccounts="isSearchingAccounts"
      :placeholder="$t('tasks.add_comment')"
      @searchAccounts="searchAccounts"
      @submit="handleSubmit"
    />
  </div>
</template>
<script>
import api from '@/api'
import mixin from '@/mixins/mixin.vue'

import MessageComposer from '@/components/MessageComposer.vue'
import { mapGetters } from 'vuex'

const SORT_BY_COINCIDENCE = '_score'

export default {
  name: 'TaskComposer',

  mixins: [mixin],

  props: {
    isLoading: Boolean,
    replyTo: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    MessageComposer,
  },

  data() {
    return {
      initialMentionedAccounts: [],
      initialContent: '',
      accountSuggestions: [],
      isSearchingAccounts: false,
    }
  },

  mounted() {
    this.searchAccounts()
  },

  computed: {
    ...mapGetters(['organizationId', 'accountId']),
  },

  watch: {
    async replyTo(account) {
      this.initialContent = ''
      await this.$nextTick()
      this.initialContent = account ? `@${account?._id ?? account?.id} ` : ''
      this.initialMentionedAccounts = account ? [account] : []
    },
  },

  methods: {
    async searchAccounts(terms) {
      try {
        this.isSearchingAccounts = true

        const response = await api.account.searchPeople(this.organizationId, {
          filters: { isDeleted: false, status: 'joined' },
          terms,
          sort: {
            by: SORT_BY_COINCIDENCE,
            order: 'desc',
          },
        })

        this.accountSuggestions =
          response?.data?.results?.map?.(result => result.account) ?? []
      } catch (err) {
        this.showError(err)
      } finally {
        this.isSearchingAccounts = false
      }
    },

    handleSubmit(comment) {
      this.$emit('submit', comment)
    },
  },
}
</script>
